import React from "react";
import PropTypes from "prop-types";
import { FormGroup, Input } from "reactstrap";

import InvalidMessage from "./InvalidMessage";

export default function TextArea(props) {
  const {
    userInput,
    onChange,
    stateKey,
    rows,
    children,
    labelText,
    invalidMessage,
    placeholder
  } = props;
  return (
    <FormGroup
      tag="fieldset"
      color={userInput.isValid === false ? "danger" : ""}
    >
      <legend>{labelText}</legend>
      <Input
        type="textarea"
        placeholder={placeholder}
        rows={rows}
        name={stateKey}
        value={userInput.val}
        className="mb-2"
        onChange={onChange.bind(null, stateKey)}
      />
      <InvalidMessage
        className="mb-4"
        isValid={userInput.isValid}
        message={invalidMessage}
      />
      {children}
    </FormGroup>
  );
}

TextArea.propTypes = {
  userInput: PropTypes.shape({
    isValid: PropTypes.bool,
    value: PropTypes.string
  }).isRequired,
  // stateKey maps to the key where the value is stored in state, and is bound to
  // the onChange handler
  stateKey: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  invalidMessage: PropTypes.string,
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
};

TextArea.defaultProps = {
  rows: 4
};

TextArea.displayName = "TextArea";



// WEBPACK FOOTER //
// ./src/Shared/Forms/TextArea.js